import { type IAgentCompanyListingsQuery } from 'application/querySchemas/IAgentCompanyListingsQuery';
import { type IAgentUserTokenRepository } from 'application/repositorySchemas/IAgentUserTokenRepository';
import {
    type IAgentCompanyListingsClient,
    IGetResponse,
} from 'interfaceAdapter/gatewaySchemas/IAgentCompanyListingsClient';
import {
    type IAgentBuyerListingsClient,
    IGetResponse as IAgentBuyerListingsResponse,
} from 'interfaceAdapter/gatewaySchemas/IAgentBuyerListingsClient';
import { inject, injectable } from 'tsyringe';

@injectable()
export class AgentCompanyListingsQuery implements IAgentCompanyListingsQuery {
    constructor(
        @inject('IAgentUserTokenRepository')
        public readonly agentUserToken: IAgentUserTokenRepository,
        @inject('IAgentCompanyListingsClient')
        public readonly agentCompanyListingsClient: IAgentCompanyListingsClient,
        @inject('IAgentBuyerListingsClient')
        public readonly agentBuyerListingsClient: IAgentBuyerListingsClient,
    ) {}

    public async fetchCompanies(params: any): Promise<IGetResponse['data']> {
        const { data, message } = await this.agentCompanyListingsClient.get({
            token: this.agentUserToken.get() || '',
            ...params,
        });
        if (message) {
            throw new Error(message);
        }
        return data;
    }

    public async fetchBuyers(params: any): Promise<IAgentBuyerListingsResponse['data']> {
        const { data, message } = await this.agentBuyerListingsClient.get({
            token: this.agentUserToken.get() || '',
            ...params,
        });
        if (message) {
            throw new Error(message);
        }
        return data;
    }
}
